import type { AgreementStatus, LinkResponse } from "@app/types";

export interface BaaHalLinks {
  self?: LinkResponse;
  organization?: LinkResponse;
  download?: LinkResponse;
}

/** Raw BAA HAL document from auth-api (snake_case + `_links`). */
export interface BaaHalResource {
  _type?: string;
  status: AgreementStatus;
  _links?: BaaHalLinks;
  adobe_agreement_id?: string;
  signing_url?: string;
  updated_at?: string;
  signed_at?: string;
}

/** Extract user-visible text from auth-api JSON error bodies (plain `{ error }` or exception HAL). */
export function messageFromAuthApiErrorBody(body: unknown): string | null {
  if (body == null) return null;
  if (typeof body === "string") return body;
  if (typeof body === "object") {
    const o = body as Record<string, unknown>;
    if (typeof o.message === "string" && o.message.trim()) return o.message;
    if (typeof o.error === "string" && o.error.trim()) return o.error;
  }
  return null;
}
